import { render, staticRenderFns } from "./AsideMenu.vue?vue&type=template&id=75ed4289"
import script from "./AsideMenu.vue?vue&type=script&lang=js"
export * from "./AsideMenu.vue?vue&type=script&lang=js"
import style0 from "./AsideMenu.vue?vue&type=style&index=0&id=75ed4289&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports